// Mock data for Local Pet Advisors Landing Page

export const BRAND = {
  name: "Local Pet Advisors",
  domain: "localpetinsuranceadvisors.com",
  quoteUrl: "https://app.prudentpet.com/?promoCode=BSG",
  phone: "202-423-0664",
  email: "adrian@petnmind.com",
  youtubeChannel: "@PetishSpeaks",
  youtubeUrl: "https://youtube.com/@PetishSpeaks",
  carrier: "Prudent Pet Insurance",
  licensedStates: ["Florida", "North Carolina", "Virginia"]
};

export const HERO_DATA = {
  headline: "Local Pet Insurance Expert Serving Florida, North Carolina & Virginia",
  subheadline: "Start with a fast online quote — customize your pet insurance with a local expert if you need more options.",
  trustLine: "Licensed Property & Casualty Insurance Agent • Binding Authority in FL, NC & VA",
  ctaText: "Get Your Free Quote Now",
  image: "https://images.pexels.com/photos/4545205/pexels-photo-4545205.jpeg"
};

export const HOW_IT_WORKS = {
  title: "How It Works",
  subtitle: "A simple process designed around you and your pet",
  steps: [
    {
      number: "01",
      title: "Get Your Online Quote",
      description: "Start with a fast, no-obligation quote from Prudent Pet Insurance. It takes just minutes and gives you immediate pricing options."
    },
    {
      number: "02",
      title: "Review Your Options",
      description: "See coverage options, deductibles, and pricing. This quote is your starting point — not a limitation on what's available."
    },
    {
      number: "03",
      title: "Customize With an Expert",
      description: "If the initial quote isn't perfect, a local licensed advisor can create a more customized plan tailored to your pet and budget."
    },
    {
      number: "04",
      title: "Get Protected",
      description: "Choose the coverage that works for you. Enjoy peace of mind knowing your pet is protected by a plan designed for their needs."
    }
  ]
};

export const WHY_DIFFERENT = {
  title: "Why Local Pet Advisors + Prudent Pet Is Different",
  subtitle: "Cover Your Tail with stress-free insurance",
  features: [
    {
      icon: "ShieldCheck",
      title: "More Coverage Options",
      description: "Access more plans and customization than buying direct from any single carrier."
    },
    {
      icon: "UserCheck",
      title: "Expert-Guided Customization",
      description: "Work with a licensed expert who tailors coverage to your pet's specific needs."
    },
    {
      icon: "DollarSign",
      title: "No Added Cost",
      description: "Working with an expert costs you nothing extra — our compensation comes from the carrier."
    },
    {
      icon: "Heart",
      title: "Human Support",
      description: "Talk to a real local advisor, not a call center halfway across the country."
    }
  ]
};

export const CUSTOMIZATION = {
  title: "Customization That Fits Your Pet & Budget",
  subtitle: "Eliminate the guesswork and avoid overpaying",
  options: [
    { icon: "Gauge", text: "Annual limits — including high or unlimited options" },
    { icon: "CircleDollarSign", text: "Flexible deductibles to match your budget" },
    { icon: "Percent", text: "Adjustable reimbursement percentages" },
    { icon: "Stethoscope", text: "Accident-only or full accident & illness plans" },
    { icon: "Sparkles", text: "Optional wellness coverage with multiple tiers" },
    { icon: "ClipboardCheck", text: "Optional veterinary exam fee coverage" }
  ],
  image: "https://images.unsplash.com/photo-1694851009504-f648f7c40c29"
};

export const QUOTE_RESCUE = {
  title: "Not Happy With Your Quote? Need More Options?",
  description: "If the initial quote doesn't feel right, don't walk away. A licensed Local Pet Advisor can create a more customized quote that better fits your pet and your budget.",
  ctaText: "Talk to a Local Pet Advisor"
};

export const POPUP_DATA = {
  headline: "Let's Customize This — No Pressure, No Obligation",
  copy: "Your online quote is just a starting point. A local licensed advisor can adjust coverage options to better match your pet and your financial comfort.",
  ctaOptions: [
    { text: "Request a Custom Quote", primary: true },
    { text: "Schedule a Call", primary: false },
    { text: "Talk to a Local Expert", primary: false }
  ]
};

export const STATE_SECTIONS = [
  {
    state: "Florida",
    abbr: "FL",
    cities: ["Miami", "Fort Lauderdale", "Tampa", "Jacksonville"],
    description: "From the sunny beaches of Miami to the vibrant streets of Jacksonville, Florida pet owners trust Local Pet Advisors for custom pet insurance solutions. Whether you have a beach-loving retriever or a condo-dwelling cat, we'll find coverage that fits your Florida lifestyle."
  },
  {
    state: "North Carolina",
    abbr: "NC",
    cities: ["Charlotte", "Raleigh", "Durham", "Concord", "Boone", "Wilmington"],
    description: "Serving pet families across the Tar Heel State — from Charlotte's urban neighborhoods to the mountains of Boone. North Carolina pet owners deserve personalized insurance options that account for local veterinary costs and lifestyle."
  },
  {
    state: "Virginia",
    abbr: "VA",
    cities: ["Richmond", "Northern Virginia"],
    description: "Virginia pet owners from Richmond to Northern Virginia trust Local Pet Advisors for expert guidance on custom pet insurance. We understand the unique needs of pets in the Commonwealth and match you with coverage that makes sense."
  }
];

export const SOCIAL_PROOF = {
  title: "Learn More About Pet Insurance",
  subtitle: "Educational content from @PetishSpeaks",
  description: "Our team shares pet insurance insights and guidance on YouTube. Learn how to make informed decisions about protecting your furry family members.",
  youtubeHandle: "@PetishSpeaks",
  youtubeUrl: "https://youtube.com/@PetishSpeaks"
};

export const ABOUT_US = {
  title: "About Local Pet Advisors",
  paragraphs: [
    "Local Pet Advisors is built by experienced insurance experts with deep roots in the pet space and a genuine passion for helping people protect what they love while building healthy financial futures.",
    "We believe pet insurance should be clear, flexible, and affordable — not confusing or one-size-fits-all. Our role is to help pet owners find cost-effective coverage options that make sense for their pets and their budgets.",
    "We work for pet parents — not call centers — and we're here to help every step of the way."
  ],
  trustLine: "Licensed Property & Casualty Insurance Experts • Serving FL, NC & VA",
  image: "https://images.unsplash.com/photo-1626735761613-a8d7a3cdfe10"
};

export const COMPLIANCE_FOOTER = {
  text: "Policies are underwritten by Prudent Pet Insurance. Coverage availability and terms vary by state. Pre-existing conditions are not covered. This website is operated by a licensed insurance expert with binding authority in Florida, North Carolina, and Virginia."
};

export const TRUSTPILOT_REVIEWS = {
  title: "What Pet Parents Are Saying",
  subtitle: "Prudent Pet Insurance is #1 rated on Trustpilot",
  trustpilotUrl: "https://www.trustpilot.com/review/prudentpet.com",
  rating: "4.8",
  totalReviews: "3,500+",
  reviews: [
    {
      name: "Sarah M.",
      location: "Miami, FL",
      rating: 5,
      title: "Best decision for my furry family",
      text: "Signing up was incredibly easy and the coverage options are amazing. When my dog needed emergency surgery, Prudent Pet covered 90% of the bill. Can't recommend enough!",
      date: "2 weeks ago"
    },
    {
      name: "Marcus T.",
      location: "Charlotte, NC",
      rating: 5,
      title: "Exceptional customer service",
      text: "The 24/7 vet chat feature alone is worth it. Quick claims processing and the team actually cares about your pets. Finally found an insurance company I trust.",
      date: "1 month ago"
    },
    {
      name: "Jennifer L.",
      location: "Richmond, VA",
      rating: 5,
      title: "Saved thousands on vet bills",
      text: "My cat was diagnosed with a chronic condition and Prudent Pet has been there every step of the way. Their coverage is comprehensive and claims are processed within days.",
      date: "3 weeks ago"
    },
    {
      name: "David & Kim R.",
      location: "Tampa, FL",
      rating: 5,
      title: "Peace of mind for our senior dog",
      text: "We were worried about finding coverage for our 9-year-old Lab but Prudent Pet offered great options. The local advisor helped us find the perfect plan.",
      date: "1 month ago"
    },
    {
      name: "Ashley W.",
      location: "Raleigh, NC",
      rating: 5,
      title: "Smooth claims process",
      text: "Submitted my first claim through the app and had my reimbursement in 5 days. No hassle, no run-around. This is how insurance should work!",
      date: "2 weeks ago"
    },
    {
      name: "Robert K.",
      location: "Northern Virginia",
      rating: 5,
      title: "Worth every penny",
      text: "After comparing multiple pet insurance companies, Prudent Pet offered the best value. The wellness add-on covers routine care too. Highly recommend!",
      date: "1 month ago"
    }
  ]
};

export const PRUDENT_PET_BENEFITS = {
  title: "Cover Your Tail",
  subtitle: "Comprehensive coverage backed by industry-leading service",
  tagline: "Stress-Free Insurance for Your Furry Family",
  benefits: [
    {
      icon: "Zap",
      title: "Lightning-Fast Claims",
      description: "75% of claims processed in 24 hours, 95% in less than a week"
    },
    {
      icon: "MessageCircle",
      title: "24/7 Live Vet Chat",
      description: "Chat with licensed veterinarians anytime, day or night — included free"
    },
    {
      icon: "PawPrint",
      title: "No Restrictions",
      description: "Every pet welcome — no age or breed restrictions whatsoever"
    },
    {
      icon: "RefreshCcw",
      title: "30-Day Guarantee",
      description: "Full refund if it's not the right fit — no questions asked"
    }
  ]
};

export const PARTNERS = {
  title: "Visit Our Partners",
  subtitle: "Trusted resources for pet owners",
  partners: [
    {
      name: "Pet N Mind",
      url: "https://www.petnmind.com",
      description: "Pet Nutrition",
      icon: "Utensils"
    },
    {
      name: "Petish Wellness Hub",
      url: "https://petishwellnesshub.com",
      description: "Pet Nutrition Coaching & Protocols",
      icon: "HeartPulse"
    },
    {
      name: "Invest In A Pet Franchise",
      url: "https://investinapetfranchise.com",
      description: "Pet N Mind Franchising",
      icon: "Building2"
    }
  ]
};
